import { Typography } from '@euler/app/components/typography';
import { WiredMemberAvatar } from '@euler/app/tv/components/MemberAvatar';
import { VerticalLine } from '@euler/app/tv/components/VerticalLine';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { MotiView } from 'moti';
import { memo, useCallback } from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from 'react-native';

export type DetailRowUserProps = {
  userId: number;
  name: string;
  title: string;
  label: string;
  onPress?: (userId: number) => void;
  onPressShade?: () => void;
};

export const DetailRowUserView = memo(
  ({
    userId,
    name,
    title,
    label,
    onPress,
    onPressShade,
  }: DetailRowUserProps) => {
    const {
      task: {
        scrollRow: {
          separatorStartColor,
          separatorEndColor,
          user: { labelTextColor, valueTextColor, detailLinkTextColor },
        },
      },
    } = usePresentationTheme();

    const { rpx } = useResponsiveContext();

    const handlePress = useCallback(() => {
      onPress?.(userId);
    }, [onPress, userId]);

    return (
      <>
        <MotiView
          from={{ opacity: 0, translateY: rpx(50) }}
          animate={{ opacity: 1, translateY: 0 }}
          transition={{ type: 'timing', duration: 500 }}
          css={`
            justify-content: flex-start;
            margin-left: ${rpx(64)}px;
            flex-direction: row;
            align-items: center;
          `}
          pointerEvents="box-none"
        >
          <TouchableWithoutFeedback onPress={onPressShade}>
            <View style={StyleSheet.absoluteFill} />
          </TouchableWithoutFeedback>
          <WiredMemberAvatar
            memberId={userId}
            size={rpx(152)}
            css={`
              border-radius: ${rpx(12)}px;
              overflow: hidden;
            `}
          />

          <View
            css={`
              margin-left: ${rpx(24)}px;
            `}
          >
            <HStack justifyContent="flex-start">
              <Typography.Label
                light
                size={rpx(24)}
                color={labelTextColor}
              >{`${label}: `}</Typography.Label>
              <Typography.Label light size={rpx(24)} color={valueTextColor}>
                {name}
              </Typography.Label>
            </HStack>

            <HStack
              justifyContent="flex-start"
              css={`
                margin-top: ${rpx(12)}px;
              `}
            >
              <Typography.Label
                light
                size={rpx(24)}
                color={labelTextColor}
              >{`技师职称: `}</Typography.Label>
              <Typography.Label light size={rpx(24)} color={valueTextColor}>
                {title}
              </Typography.Label>
            </HStack>

            <TouchableOpacity
              onPress={handlePress}
              css={`
                margin-top: ${rpx(13)}px;
              `}
            >
              <Typography.Label
                light
                size={rpx(20)}
                color={detailLinkTextColor}
              >
                {`查看技师详情 >`}
              </Typography.Label>
            </TouchableOpacity>
          </View>
        </MotiView>

        <VerticalLine
          startColor={separatorStartColor}
          endColor={separatorEndColor}
          css={`
            height: 50%;
            margin-left: ${rpx(60)}px;
            margin-right: ${rpx(60)}px;
            align-self: center;
          `}
        />
      </>
    );
  },
);
